import { Component, OnInit } from '@angular/core';
import { TeacherService } from './../teacher.service';
@Component({
  selector: 'app-mc-analysis',
  templateUrl: './mc-analysis.component.html',
  styleUrls: ['./mc-analysis.component.css']
})
export class McAnalysisComponent implements OnInit {

  mcdetails;
  constructor(
    private teacherService: TeacherService
  ) { }

  ngOnInit() {
    console.log("Init MC Panel")
    this.mcdetails = this.teacherService.getMCDetailsAnalysis();
  }

}
